import { Check, X } from "lucide-react";
import { Reveal } from "@/components/landing/primitives";
import { Eyebrow, H2 } from "./shared";

const PAIRS = [
  ["Signals with no history", "Every setup published and resolved, wins and losses"],
  ["Lagging indicators on TradingView", "Order flow from real executed trades"],
  ["Twitter hype and recycled headlines", "Impact-ranked news with measured price reaction"],
  ["Guessing whether a coin is worth it", "Research scorecards on liquidity, supply and activity"],
  ["Five tabs and three subscriptions", "One terminal, institutional data, retail price"],
];
const NEVER = ["Sell you 'guaranteed' signals", "Post profit screenshots or lifestyle marketing", "Hide losing trades", "Run a paid group that front-runs you", "Pretend this is financial advice"];

export const GetVsNever = () => (
  <section id="difference" data-testid="get-vs-never" className="border-t border-white/[0.06] bg-[#08090B] py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal className="max-w-3xl">
        <Eyebrow>The difference</Eyebrow>
        <H2 className="mt-5">Most traders get noise. <span className="text-[#7D8390]">You get the edge.</span></H2>
      </Reveal>
      <div className="mt-14 grid gap-12 lg:grid-cols-[1.6fr_1fr]">
        <Reveal className="border border-white/[0.07]">
          <div className="grid grid-cols-2 border-b border-white/[0.07] font-mono text-[10px] uppercase tracking-[0.22em]">
            <span className="p-4 text-[#5A6170] md:px-6">What most traders get</span>
            <span className="border-l border-white/[0.07] bg-white/[0.02] p-4 text-[#ECEBE4] md:px-6">With TradrQuant</span>
          </div>
          {PAIRS.map(([a, b], i) => (
            <div key={a} data-testid={`diff-row-${i}`} className="grid grid-cols-2 border-b border-white/[0.05] last:border-b-0">
              <span className="flex gap-3 p-4 text-sm text-[#7D8390] md:px-6"><X size={15} className="mt-0.5 shrink-0 text-white/20" />{a}</span>
              <span className="flex gap-3 border-l border-white/[0.07] bg-white/[0.02] p-4 text-sm text-[#ECEBE4] md:px-6"><Check size={15} className="mt-0.5 shrink-0 text-[#BACD1C]/80" />{b}</span>
            </div>
          ))}
        </Reveal>
        <Reveal delay={0.1} data-testid="never-list">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#7D8390]">What we'll never do</p>
          <ul className="mt-6 divide-y divide-white/[0.06] border-y border-white/[0.06]">
            {NEVER.map((n) => <li key={n} className="flex items-center gap-3 py-4 text-[15px] text-[#ECEBE4]"><span className="font-mono text-[#FF4D5A]/80">✕</span>{n}</li>)}
          </ul>
        </Reveal>
      </div>
    </div>
  </section>
);
